var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex align-items-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }